import {motion} from 'framer-motion';
import React from 'react';
import styled, {css} from 'styled-components';

import {Device} from '../../../constants';

const Heroes = {
  ironman: css`
    font-size: 16vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 4em !important;
    }
  `,
  storm: css`
    font-size: 20vw !important;
  `,
  groot: css`
    font-size: 20vw !important;
  `,
  mystique: css`
    font-size: 16vw !important;
  `,
  thor: css`
    font-size: 25vw !important;
  `,
  doom: css`
    font-size: 18vw !important;
  `,
  shehulk: css`
    font-size: 16vw !important;
  `,
  hero: css`
    font-size: 16vw !important;
  `,
  poseidon: css`
    font-size: 10vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 12vw !important;
    }
  `,
  aphrodite: css`
    font-size: 16vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 20vw !important;
    }
  `,
  hades: css`
    font-size: 8vw !important;
  `,
  aries: css`
    font-size: 8vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 12vw !important;
    }
  `,
  hera: css`
    font-size: 12vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 16vw !important;
    }
  `,
  hercules: css`
    font-size: 14vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 16vw !important;
    }
  `,
  athena: css`
    font-size: 10vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 10vw !important;
    }
  `,
  unidentified: css`
    font-size: 10vw !important;
    @media screen and ${Device.mobileL} {
      font-size: 14vw !important;
    }
  `,
};

const HeroName = styled(({...rest}) => <motion.h1 {...rest} />)`
  color: #fff;
  font-style: italic;
  white-space: nowrap;
  line-height: 1 !important;
  width: 100%;
  text-align: center;
  ${(props) => Heroes[props.keyId]}

  @media screen and (max-width: 940px) {
    top: 50%;
  }
`;

export default HeroName;
